import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { menuNav_template } from "../components/templates/menuNav_template";
import { getMenusWithSelection } from "./menu_data";
export class menu_mod extends vnModule_knockoutJS {
    getModuleName() {
        return "main-nav";
    }
    buildContent() {
        this.menu = new menuNav_template("mainMenu", this.viewModel, this);
        const vnApp = this.getVnAppZone().app;
        if (vnApp.loggedUser != null && vnApp.loggedUser.isLoggedIn) {
            this.menu.setIsUserLoggedIn(true);
            this.menu.setMenus(getMenusWithSelection());
        }
        return [this.menu.build()];
    }
    fillPage() {
        // no fill
    }
}
